import React, { useEffect, useState } from "react";
import { Form, Field, ErrorMessage, useFormikContext } from "formik";
import LocationAutocomplete from "../../components/LocationAutocomplete";
import { formatIBAN } from "../../utils/utils";
import { useLoadScript } from "@react-google-maps/api";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useDispatch } from "react-redux";
import { FirstupdatedEtablissement, getMyEtablissement, updatedEtablissement } from "../../store/slices/etablissementSlice";
import { toast } from "react-toastify";
import TooltipTwyny from "../tooltip";

const libraries = ["places"];

export const EstablishmentForm = ({
  from,
  isSubmitting,
  // handleFooterSubmit,
  selectedEtablissement,
  userVerifications
 
}) => {
  const dispatch=useDispatch()
  const { values, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext();
    //  console.log({values})
  const [isCompleted, setIsCompleted] = useState(true);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const [isExpanded, setIsExpanded] = useState(
    from === "account" ? false : true
  );
  const checkSiret = async (value) => {
    if (!value || value.length !== 14) return false;
    try {
      const response = await fetch(`https://api.insee.fr/api-sirene/3.11/siret/${value}`, {
        headers: { 'X-INSEE-Api-Key-Integration': process.env.REACT_APP_CONSUMER_KEY }
      });
      return response.ok;
    } catch {
      return false;
    }
  };
    const handleCinRectoChange = (event, setFieldValue) => {
      const file = event.currentTarget.files[0];
      setFieldValue("cinRecto", file);
    };
    
    const handleCinVersoChange = (event, setFieldValue) => {
      const file = event.currentTarget.files[0];
      setFieldValue("cinVerso", file);
    };
  const handleSubmitInfoEtablissement = async () => {
    
    try {
      // Validation checks
    
      if (!values.nom || values.nom.length > 125) {
        toast.error("Le nom de l'établissement est requis et doit faire moins de 125 caractères");
        return;
      }
  
      if (!values.description || values.description.length > 1000) {
        toast.error("La description est obligatoire et ne doit pas dépasser 1000 caractères");
        return;
      }
  
      if (!values.companyAddress) {
        toast.error("L'adresse de l'établissement est requise");
        return;
      }
      if (!values.cinRecto && from!=="account") {
        toast.error("CNI Recto est requis");
        return;
      }
  
      const cleanedIban = values?.iban?.replace(/\s+/g, "");
      if (!cleanedIban ) { // French IBAN length is 27 characters
        toast.error("Veuillez entrer un IBAN français valide");
        return;
      }
   const isSiretValid = await checkSiret(values.siret);
      if (!isSiretValid) {
        toast.error("Le SIRET n'existe pas dans la base INSEE");
        return;
      }
      const formData = new FormData();
    
      // Append all existing fields
      formData.append('iban', cleanedIban);
      formData.append('nom', values.nom);
      formData.append('lat', values.lat?.toString());
      formData.append('lng', values.lng?.toString());
      formData.append('siret', values.siret);
      formData.append('code_postal', values.postalCode);
      formData.append('tva', values.tva);
      formData.append('adresse_postale', values.companyAddress);
      formData.append('description', values.description);
      formData.append('ville', values.city); 
      
      // Append the CIN files
      if (values.cinRecto) formData.append('identity_document_front', values.cinRecto);
      if (values.cinVerso) formData.append('identity_document_back', values.cinVerso);
      
      // console.log('hello',selectedEtablissement)
  
      if (selectedEtablissement) {
        await dispatch(
          FirstupdatedEtablissement({
            etablissementData: formData,
            route: `etablissements/${selectedEtablissement?.id}/first-update`,
          })
        ).unwrap();
        toast.success("Informations de l'établissement mises à jour avec succès");
        dispatch(getMyEtablissement());
      }
    } catch (error) {

      toast.error("Veuillez vérifier vos informations");
        // error?.data?.error || error?.data?.message || "Erreur lors de la mise à jour des informations"
      
    }
  };
     
  const handleLocationSelect = (place) => {
    if (!place) {
      setFieldValue("companyAddress", "");
      setFieldValue("lat", null);
      setFieldValue("lng", null);
      setFieldValue("postalCode", null);
      setFieldValue("city", null);
      return;
    }

    setFieldValue("companyAddress", place.description);

    if (isLoaded && window.google?.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ placeId: place.place_id }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          let city = "";
          let postalCode = "";

          results[0].address_components.forEach((component) => {
            if (component.types.includes("locality"))
              city = component.long_name;
            if (component.types.includes("postal_code"))
              postalCode = component.long_name;
          });

          setFieldValue("lat", location.lat());
          setFieldValue("lng", location.lng());
          setFieldValue("postalCode", postalCode);
          setFieldValue("city", city);
        }
      });
    }
    setFieldTouched("companyAddress", true);
  };

  const formatUpdateDate = (dateString) => {
    if (!dateString) return "Non mis à jour";
    const date = new Date(dateString);
    return format(date, "dd/MM/yy", { locale: fr });
  };
useEffect(()=>{
  setIsCompleted(values?.nom!=="" && values.companyAddress!=="" && values?.iban!==""  && values?.siret!=="")
 
},[values])
  return (
    <div className="">
      <div className="">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {from === "account" ? (
            <h4 className="grey500">
              Informations d'établissement{" "}
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <img
                  src={
                    isExpanded
                      ? "/images/chevron-down.svg"
                      : "/images/chevron-down.svg"
                  }
                  className={`w-6 h-6 ${!isExpanded ? "rotate180" : ""}`}
                  alt={isExpanded ? "Réduire" : "Ouvrir"}
                />
              </button>
            {!isCompleted && selectedEtablissement  ? <img src="/images/notCompleted.svg" alt="not completed icon" className="ml-8" />:''}

            </h4>
          ) : (
            <h3 className="grey500">Informations d'établissement </h3>
          )}

          {from === "account" && (
            <div className="d-flex align-items-center">
              {selectedEtablissement?.updated_at && (
                <span className="body grey66 mr-16">
                  Dernière mise à jour:{" "}
                  {formatUpdateDate(selectedEtablissement.updated_at)}
                </span>
              )}
            </div>
          )}
        </div>

        {isExpanded && (
          <>
            <p className="body grey66 mt-16">
              Attention, toutes les informations complétées sur la page
              établissement seront visibles des utilisateurs Twyny.
            </p>

            <Form className="register-form mt-24">
              <div className="row">
                <div className="col-md-12">
                  <div className="input-wrapper">
                    <label className="form-label">
                      Nom de l'établissement*
                    </label>
                    <Field
                      name="nom"
                      value={values.nom}
                      placeholder="Nom de l'établissement"
                      className={`padding-input-text ${
                        touched.nom && errors.nom ? "is-invalid" : ""
                      }`}
                      maxLength={125}
                    />
                    <ErrorMessage name="nom">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Error"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                  </div>
                </div>

                <div className="input-wrapper mt-16">
                  <label className="form-label">
                    Adresse de l'établissement*
                  </label>
                  <div className="relative">
                    <LocationAutocomplete
                      onLocationSelect={handleLocationSelect}
                      isGoogleLoaded={isLoaded}
                      value={values.companyAddress}
                    />
                  </div>

                  <ErrorMessage name="companyAddress">
                    {(msg) => (
                      <div className="error-message mt-1">
                        <img
                          src="/images/alert-circle.svg"
                          className="arrow mr-8"
                          alt="Error"
                        />
                        {msg}
                      </div>
                    )}
                  </ErrorMessage>
                </div>
              </div>
              <div className="input-wrapper">
                      <label className="form-label">SIRET*</label>
                      <Field
                        name="siret"
                        placeholder="SIRET de l'entreprise"
                        className={`padding-input-text ${
                          touched.siret && errors.siret ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        name="siret"
                        component="div"
                        className="error-message mt-1"
                      />
                    </div>

                    <div className="input-wrapper">
                      <label className="form-label">Numéro de TVA</label>
                      <Field
                        name="tva"
                        placeholder="Numéro de TVA"
                        className={`padding-input-text ${
                          touched.tva && errors.tva ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        name="tva"
                        component="div"
                        className="error-message mt-1"
                      />
                    </div>
                  
              <div className="col-md-12 input-wrapper">
                <label>Description de l'établissement*</label>
                <Field
                  as="textarea"
                  name="description"
                  className="padding-input-text input-wrapper form-control"
                  placeholder=" "
                  rows={5}
                  maxLength={1000}
                />
                 <ErrorMessage name="description">
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Error"
                      />
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </div>

              <p className="body grey66 mb-0">
                Renseignez votre IBAN afin de pouvoir être payé pour vos
                prestations :
              </p>

              <div className="input-wrapper">
                <label className="form-label">IBAN* 
                  <TooltipTwyny
                  children={
                    <img
                      src="/images/information-circle-contained.svg"
                      alt="information icon"
                      className="ml-8"
                    />
                  }
                  className={""}
                  text="Votre IBAN ne sera utilisé que pour  la facturation de vos prestations, et n’apparaitra pas sur votre page d’établissement"
                /> </label>
                <Field
                  name="iban"
                  placeholder="FR00 0000 0000 0000 0000 0000 000"
                  value={values.iban}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/\s+/g, "");
                    if (rawValue.length <= 27) {
                      setFieldValue("iban", formatIBAN(rawValue));
                    }
                  }}
                  className={`padding-input-text ${
                    touched.iban && errors.iban ? "is-invalid" : ""
                  }`}
                />
                <ErrorMessage name="iban">
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Error"
                      />
                      {msg}
                    </div>
                  )}
                </ErrorMessage>
              </div>
              <div className="row mt-4">
                      <div className="col-md-12">
                        <p className="body bold500 grey500 mb-0">Pièce d’identité - côté recto* 
                       
                  <TooltipTwyny
                  children={
                    <img
                      src="/images/information-circle-contained.svg"
                      alt="information icon"
                      className="ml-8"
                    />
                  }
                  className={""}
                  text="Ce document est transmis directement à Stripe, organisme habilité à effectuer la vérification d’identité (KYC). Il n’est à aucun moment conservé sur nos serveurs"
                />
                        </p>
                        <div className=" mt-8">
                          <label
                            htmlFor="cin-recto"
                            className="import-photos custom-dashed mt-8"
                          >
                            <img
                              src="/images/download-02.svg"
                              alt="download icon"
                            />
                            {values.cinRecto ? (
                            <div className="mt-2">
                              <span className="badge bg-primary">
                                {values.cinRecto.name}
                              </span>
                            </div>
                          ): <p className="body bold500 primary text-center mt-8 mb-0">
                            Ajouter votre pièce d’identité
                            </p>
                          }
                           
                          </label>
                          <input
                            id="cin-recto"
                            type="file"
                            accept="image/jpeg, image/png"
                            onChange={(e) =>
                              handleCinRectoChange(e, setFieldValue)
                            }
                            className="d-none"
                          />
                          <p className="mt-8 legend grey66">
                            Taille maximale 1920 x 1080 px; Formats autorisés : jpg, png;
                            Poids maximal : 2Mo
                          </p>
                          <ErrorMessage
                            name="cinRecto"
                            component="div"
                            className="error-message mt-1"
                          />
                          
                        </div>
                      </div>

                      <div className="col-md-12 mt-32">
                      <p className="body bold500 grey500 mb-0">Pièce d’identité - côté verso</p>
                        <div className=" mt-8">
                          <label
                            htmlFor="cin-verso"
                            className="import-photos custom-dashed mt-8"
                          >
                            <img
                              src="/images/download-02.svg"
                              alt="download icon"
                            />
                             {values.cinVerso ? (
                            <div className="mt-2">
                              <span className="badge bg-primary">
                                {values.cinVerso.name}
                              </span>
                            </div>
                          )
                        :<p className="body bold500 primary text-center mt-8 mb-0">
                            Ajouter votre pièce d’identité
                            </p>}
                            
                          </label>
                          <input
                            id="cin-verso"
                            type="file"
                            accept="image/jpeg, image/png"
                            onChange={(e) =>
                              handleCinVersoChange(e, setFieldValue)
                            }
                            className="d-none"
                          />
                          <p className="mt-8 legend grey66">
                            Taille maximale 1920 x 1080 px; Formats autorisés : jpg, png;
                            Poids maximal : 2Mo
                          </p>
                          <ErrorMessage
                            name="cinVerso"
                            component="div"
                            className="error-message mt-1"
                          />
                         
                        </div>
                      </div>
                    </div>
              {from === "account" ? (
                <button
                  // type="submit"
                    onClick={handleSubmitInfoEtablissement}
                  className="twyny-cta-primary"
                >
                  Enregistrer les modifications
                </button>
              ) : (
                ""
              )}
            </Form>
          </>
        )}
      </div>
    </div>
  );
};
